import { gql } from '@lcs/shared/api';

export const ExternalNumbersQuery = gql`
   query ExternalNumberHistories($filters: String) {
      externalNumberHistoriesConnection(filters: $filters) {
         totalCount
         items {
            externalNumberHistoryId
            accountId
            externalNumber
         }
      }
   }
`;
